import React, { useEffect } from 'react';
import { ExcelExport, ExcelExportColumn, ExcelExportColumnGroup } from '@progress/kendo-react-excel-export';
import moment from 'moment';

const ExportExcelComponents = (props: any) => {

    const exportRef = React.createRef<ExcelExport>();

    useEffect(() => {
        if (props?.ExportFileName == "MaintenanceHistory") {
            save(exportRef)
        } else {
            exportRef?.current?.save();
        }
        props?.setMount({ flag: false, data: props?.data });
    }, []);

    const save = (component: any) => {
        const options = component?.current?.workbookOptions();
        const rows = options?.sheets[0]?.rows;
        const gridData = component?.current?.props?.data;
        rows.forEach((row: any, index = 1) => {
            if (row.type === "data") {
                row.cells[4].bold = true;
                row.cells[4].color = gridData[index - 1].color;
                row.cells[4].value = row.cells[4].value?.startsWith("-") ? row.cells[4].value : "+" + row.cells[4].value;
            }
        });

        component.current.save(options);

    };

    return <ExcelExport
        fileName={props?.ExportFileName + moment().format("YYYYMMDDhhmmss") + ".xlsx"}
        data={props?.data ?? []} ref={exportRef}>

        {props?.ExcelGrouping ?
            props.exportColumn.map((item: any, index: any) => (
                (!item?.children) ?
                    <ExcelExportColumn key={item?.field}
                        title={item?.title}
                        field={item?.field}
                        width={item?.width}
                    /> :
                    <ExcelExportColumnGroup
                        key={item?.title}
                        title={item?.title}
                        headerCellOptions={{
                            textAlign: "center",
                        }} >
                        {item?.children.map((child: any) => (
                            <ExcelExportColumn key={child?.field}
                                title={child?.title}
                                field={child?.field}
                                width={child?.width}
                            />
                        ))}
                    </ExcelExportColumnGroup>
                        
            ))
            :
            props.exportColumn.map((item: any, index: any) => (
                <ExcelExportColumn
                    key={item?.field}
                    title={item?.title}
                    field={item?.field}
                    width={item?.width}
                    cellOptions={{format: item?.excelFormat || ''}}                
                />
            ))}

    </ExcelExport>
}

export default ExportExcelComponents;
